const apiServer = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:8000/poa/2022/';
const apiBase = process.env.REACT_APP_BASE_API_URL ? process.env.REACT_APP_BASE_API_URL : 'http://localhost:8000/poa/';

const Config = {
  endpoints: {
    memberstates: `${apiServer}country`,
    reports: `${apiServer}reports`,
    npc: `${apiServer}point-of-contact`,
    npcComplete: `${apiServer}country-latest/contacts`,
    participation: `${apiServer}participation`,
    assistanceSeekers: `${apiServer}assistance`,
    unroca: `${apiServer}unroca/`,
    diversionCountry: `${apiBase}diversion-country`,
    regionalOrganization: `${apiBase}regionalOrganization`,
    oecd: `${apiServer}country/oecd`,
    countryprofile: `${apiServer}country-reports`,
    lastReports: `${apiServer}country-report-latest`,
    sdg: `${apiServer}salw-stats`,
    comtrade: `${apiServer}country/comtrade`,
    statistics: `${apiServer}global-stats`,
  },
  reportYear: 2022,
};

export default Config;



// WEBPACK FOOTER //
// ./src/config.js